import { useMemo } from "react";
import { useSelector } from "react-redux";

export default (auditId, itemsToShow = 10) => {
    const { altAssets, assetAuditors, auditAssets } = useSelector(
        (state) => state
    );

    let dataChecked = useMemo(() => {
        const aID = parseInt(auditId);

        return [
            ...altAssets.data.filter((item) => item.audit.id === aID), // excluded assets
            ...auditAssets.data // checked assets
                .filter((item) => item.isAssigned),
        ];
    }, [altAssets.data, assetAuditors.data, auditAssets.data]);

    const checkedCount = dataChecked.length;
    dataChecked = dataChecked.slice(0, itemsToShow);

    return [checkedCount, dataChecked];
};
